import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider, GasConfirmProvider } from '../../shared/kit';
import App from './App';
import type { InitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-member-search-app');

if (mountEl?.dataset.reactInit) {
    let initData: InitData | null = null;

    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as InitData;
    } catch (error) {
        mountEl.innerHTML = '';
        throw error;
    }

    if (initData && mountEl.isConnected) {
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasQueryProvider>
                    <GasToastProvider>
                        <GasConfirmProvider>
                            <App initData={initData} />
                        </GasConfirmProvider>
                    </GasToastProvider>
                </GasQueryProvider>
            </React.StrictMode>,
        );
    }
}
